import React from 'react';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-noise" />
      <div className="hero-scanlines" />
      
      <div className="hero-content">
        <img 
          src="https://customer-assets.emergentagent.com/job_inkedpages/artifacts/v0mkuce6_larger_unreal_owl.png" 
          alt="Unreal Press Logo" 
          className="hero-logo"
        />
        <h1 className="hero-title glitch-once" data-text={companyInfo.name}>
          {companyInfo.name}
        </h1>
        <p className="hero-tagline">
          {companyInfo.tagline}
        </p>
      </div>
      
      <div className="hero-border-top" />
      <div className="hero-border-bottom" />
    </section>
  );
};

export default HeroSection;
